export const processConstants = {
    PROCESS: 'process',
    PROCESS_START: 'process:start',
    PROCESS_STOP: 'process:stop',
    PROCESS_CLEAR: 'process:clear',
    PROCESS_FAILURE: 'process:failure',
};
